import React, { Component } from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallText from '../../../common-components/common-small-text';

class SeoHeader extends Component {
    render() {
        return (
            <FullWrapper className="seo-architecture" smallPaddings={true}>
                <h1 className="common__title">SEO для финтеха:</h1>
                <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                    <CommonSmallText>
                        типичные ошибки и практические <br /> советы по поисковой оптимизации
                    </CommonSmallText>
                </ScrollAnimation>
            </FullWrapper>
        );
    }
}

export default SeoHeader;
